import { SxProps, Theme } from "@mui/material";

const styles = {
  container: { pb: 1 } satisfies SxProps<Theme>,
  intro: { textAlign: "center", mb: 1 } satisfies SxProps<Theme>,
  title: {
    fontSize: { xs: 20, md: 24 },
    fontWeight: 700,
  } satisfies SxProps<Theme>,
};

export default styles;
